import { Badge, type BadgeProps, cn } from "@au-schein-de/au-ui-library";
import type { JSX } from "react";
import { ProductCardCannabinoidBadge } from "./product-card-cannabinoid-badge.component";
import { useAdaptiveCannabinoidLabelPair } from "./use-adaptive-cannabinoid-label.hook";

type ProductCardCannabinoidBadgeRowProps = {
	thcFullLabel: string;
	thcShortLabel: string;
	cbdFullLabel: string;
	cbdShortLabel: string;
	size: BadgeProps["size"];
	compactPadding?: boolean;
};

export function ProductCardCannabinoidBadgeRow({
	thcFullLabel,
	thcShortLabel,
	cbdFullLabel,
	cbdShortLabel,
	size,
	compactPadding = false,
}: ProductCardCannabinoidBadgeRowProps): JSX.Element {
	const { rowRef, fullMeasureRowRef, thc, cbd, variant } =
		useAdaptiveCannabinoidLabelPair(
			{ fullLabel: thcFullLabel, shortLabel: thcShortLabel },
			{ fullLabel: cbdFullLabel, shortLabel: cbdShortLabel },
		);
	const measureBadgeClassName = cn(
		"whitespace-nowrap",
		compactPadding && "p-1",
	);

	return (
		<div
			ref={rowRef}
			className="relative flex min-w-0 w-full gap-1 items-start"
		>
			<ProductCardCannabinoidBadge
				label={thc.label}
				title={thc.title}
				variant={variant}
				size={size}
				testId="product-list-item-thc"
				compactPadding={compactPadding}
			/>
			<ProductCardCannabinoidBadge
				label={cbd.label}
				title={cbd.title}
				variant={variant}
				size={size}
				testId="product-list-item-cbd"
				compactPadding={compactPadding}
			/>
			<div
				ref={fullMeasureRowRef}
				aria-hidden
				data-testid="cannabinoid-full-measure-row"
				className="pointer-events-none invisible absolute top-0 left-0 flex w-max gap-1"
			>
				<Badge size={size} className={measureBadgeClassName}>
					{thcFullLabel}
				</Badge>
				<Badge size={size} className={measureBadgeClassName}>
					{cbdFullLabel}
				</Badge>
			</div>
		</div>
	);
}
